import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/svg/hole_type2.svg'


const _hoisted_1 = { style: {"width":"100%"} }
const _hoisted_2 = { class: "hierarchy-top" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fad fa-bars" }, null, -1)
const _hoisted_4 = { class: "hierarchy-columns" }
const _hoisted_5 = { class: "hierarchy-column" }
const _hoisted_6 = { style: {"display":"flex","width":"100%","position":"relative"} }
const _hoisted_7 = { class: "hierarchy-inner" }
const _hoisted_8 = ["onMousedown"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-grip-vertical" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "arrow" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-arrow-right" })
], -1)
const _hoisted_11 = { class: "hierarchy-column" }
const _hoisted_12 = { style: {"display":"flex","align-items":"center","width":"100%"} }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-sync" }, null, -1)
const _hoisted_14 = {
  class: "hierarchy-inner",
  style: {"padding-bottom":"100px"}
}
const _hoisted_15 = {
  key: 1,
  style: {"margin-top":"0"},
  class: "drop-option"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-grip-vertical" }, null, -1)
const _hoisted_17 = { class: "hierarchy-column" }
const _hoisted_18 = { style: {"display":"flex","width":"100%"} }
const _hoisted_19 = {
  class: "hierarchy-inner",
  style: {"padding-bottom":"100px","gap":"5px","background":"#fff"}
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", null, "1A12123", -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { key: 0 }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-caret-right",
  style: {"margin-right":"10px"}
}, null, -1)
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { style: {"margin-top":"0","font-size":"10pt","display":"flex","align-items":"center","gap":"10px"} }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("img", {
  style: {"height":"100%","max-height":"13px"},
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_27 = { style: {"margin-left":"15px","font-size":"10pt"} }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-caret-down",
  style: {"margin-right":"10px"}
}, null, -1)
const _hoisted_29 = { class: "import-dialog-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_imdex_btn = _resolveComponent("imdex-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, [
        _hoisted_3,
        _createTextVNode("  " + _toDisplayString(_ctx.$t("import.hierarchySelection.title")), 1)
      ]),
      _createElementVNode("span", null, _toDisplayString(_ctx.$t("import.hierarchySelection.subTitle")), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t("import.hierarchySelection.columnsListTitle")), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.properties, (item, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: i,
              onMousedown: ($event) => _ctx.dragStart($event, item),
              class: "hierarchy-drag-item"
            }, [
              _hoisted_9,
              _createTextVNode(" " + _toDisplayString(item.name), 1)
            ], 40, _hoisted_8))
          }), 128)),
          _hoisted_10
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t("import.hierarchySelection.selectedTitle")), 1),
          _createVNode(_component_imdex_btn, {
            fab: "",
            compact: "",
            onClick: _ctx.reset,
            style: {"margin-left":"auto"},
            dark: "",
            disabled: _ctx.hierarchy.length == 0
          }, {
            default: _withCtx(() => [
              _hoisted_13
            ]),
            _: 1
          }, 8, ["onClick", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_14, [
          (_ctx.hierarchy.length > 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "dashed-border",
                style: _normalizeStyle(`height:${
							_ctx.properties.length > 0 ? 85 : 45
						}px; width:${15}px; transform:translateX(${
							15 * (_ctx.hierarchy.length - 1)
						}px) translateY(${60 * (_ctx.hierarchy.length - 1)}px)`)
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("import.hierarchySelection.defaultColName")), 1)
              ], 4))
            : _createCommentVNode("", true),
          (_ctx.hierarchy.length == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.$t("import.hierarchySelection.dragHint")), 1))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.hierarchy, (item, i) => {
                return (_openBlock(), _createElementBlock("div", { key: i }, [
                  _createElementVNode("div", {
                    class: "filled-hierarchy",
                    style: _normalizeStyle(`margin-left:${15 * i + 1}px`)
                  }, [
                    (_ctx.hierarchy.length > i + 1)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "dashed-border",
                          style: _normalizeStyle(`height:${25}px; width:${15}px; transform:translateX(${-24}px) translateY(${-25}px)`)
                        }, null, 4))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", null, [
                      _hoisted_16,
                      _createTextVNode(_toDisplayString(item.name), 1)
                    ]),
                    (_ctx.hierarchy.length < i + 2 && _ctx.properties.length > 0)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "drop-option",
                          style: _normalizeStyle(`width:calc(100% - ${15 * 1}px);`)
                        }, _toDisplayString(_ctx.$t("import.hierarchySelection.dragHint")), 5))
                      : _createCommentVNode("", true)
                  ], 4)
                ]))
              }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t("import.hierarchySelection.exampleTitle")), 1)
        ]),
        _createElementVNode("div", _hoisted_19, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList([0, 1, 2, 3], (e, i) => {
            return _createElementVNode("div", {
              key: i,
              class: "dashed-border",
              style: _normalizeStyle(`height:${12.5 + 15 * i}px; width:${15}px; left:${
							24 +
							(_ctx.hierarchy.length > 1 ? _ctx.hierarchy.length * 16 : _ctx.hierarchy.length * 19)
						}px; top:${45 + 5 * _ctx.hierarchy.length}px; transform:translateX(${
							0 * _ctx.hierarchy.length
						}px) translateY(${15 * _ctx.hierarchy.length}px)`)
            }, _hoisted_21, 4)
          }), 64)),
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList([0, 1, 2, 3], (e, i) => {
            return _withDirectives(_createElementVNode("div", {
              key: i,
              class: "dashed-border",
              style: _normalizeStyle(`height:${15 * _ctx.hierarchy.length + 84 + 15 * i}px; left:24px; top:${
							50 + 2 * _ctx.hierarchy.length
						}px; width:${10}px;transform:translateX(${0}px) translateY(${0}px)`)
            }, [
              (_ctx.hierarchy.length > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                    _hoisted_23,
                    _createTextVNode(_toDisplayString(_ctx.hierarchy[0].name.replaceAll(" ", "").substr(0, 4).toUpperCase() +
								Math.floor(Math.random() * 500)), 1)
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_24, "1a1123123"))
            ], 4), [
              [_vShow, _ctx.hierarchy.length > 0]
            ])
          }), 64)),
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("import.hierarchySelection.dsExample")), 1)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hierarchy, (item, i) => {
            return (_openBlock(), _createElementBlock("div", { key: i }, [
              _createElementVNode("div", {
                class: "filled-hierarchy",
                style: _normalizeStyle(`margin-left:${15 * i + 1}px; height:15px;`)
              }, [
                (_ctx.hierarchy.length > i + 1)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "dashed-border",
                      style: _normalizeStyle(`height:${20}px; width:${10}px; top:0; transform:translateX(${-9}px) translateY(${15}px)`)
                    }, null, 4))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _createTextVNode(_toDisplayString(item.name.replaceAll(" ", "").substr(0, 4).toUpperCase() +
									Math.floor(Math.random() * 500)), 1)
                ])
              ], 4)
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_29, [
      _createVNode(_component_imdex_btn, {
        id: "hierarchy-cancel",
        small: "",
        text: ""
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("import.hierarchySelection.cancelBtn")), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_imdex_btn, {
        id: "hierarchy-continue",
        small: "",
        secondary: ""
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("import.hierarchySelection.continueBtn")), 1)
        ]),
        _: 1
      })
    ])
  ]))
}